/* src/components/Solar/Hero.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	append_hydration,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert_hydration,
	mount_component,
	safe_not_equal,
	set_data,
	space,
	src_url_equal,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

import { onMount } from 'svelte';

import {
	roundToMax2Decimals,
	roundFormat,
	formatBigNumber
} from '../../helpers/svelte/utils/formatters';

import getGraphqlClient from '../../helpers/svelte/utils/getGraphqlClient';
import gql from 'nanographql';
import Tooltip from '../Tooltip/Tooltip.svelte';
import StatePath from '../ZoomableMap/components/StatePath/StatePath.svelte';

function create_if_block_6(ctx) {
	let t0;
	let t1_value = /*locationInfo*/ ctx[2].state_slug.toUpperCase() + "";
	let t1;

	return {
		c() {
			t0 = text(", ");
			t1 = text(t1_value);
		},
		l(nodes) {
			t0 = claim_text(nodes, ", ");
			t1 = claim_text(nodes, t1_value);
		},
		m(target, anchor) {
			insert_hydration(target, t0, anchor);
			insert_hydration(target, t1, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*locationInfo*/ 4 && t1_value !== (t1_value = /*locationInfo*/ ctx[2].state_slug.toUpperCase() + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
		}
	};
}

// (195:12) {#if !selectedCounty && solarStateRanks}
function create_if_block_4(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_5, create_else_block_2];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*solarStateRanks*/ ctx[4].systemPriceRank <= rankLimit) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, [-1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (201:14) {:else}
function create_else_block_2(ctx) {
	let tooltip;
	let current;

	tooltip = new Tooltip({
			props: {
				text: "" + (/*name*/ ctx[0] + " ranks #" + /*solarStateRanks*/ ctx[4].systemPriceRank + " for cheapests system prices in the US.")
			}
		});

	return {
		c() {
			create_component(tooltip.$$.fragment);
		},
		l(nodes) {
			claim_component(tooltip.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(tooltip, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const tooltip_changes = {};
			if (dirty[0] & /*name, solarStateRanks*/ 17) tooltip_changes.text = "" + (/*name*/ ctx[0] + " ranks #" + /*solarStateRanks*/ ctx[4].systemPriceRank + " for cheapests system prices in the US.");
			tooltip.$set(tooltip_changes);
		},
		i(local) {
			if (current) return;
			transition_in(tooltip.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tooltip.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(tooltip, detaching);
		}
	};
}

// (196:14) {#if solarStateRanks.systemPriceRank <= rankLimit}
function create_if_block_5(ctx) {
	let tooltip;
	let current;

	tooltip = new Tooltip({
			props: {
				icon: "green-star",
				text: "" + (/*name*/ ctx[0] + " ranks #" + /*solarStateRanks*/ ctx[4].systemPriceRank + " for the top " + rankLimit + " cheapests system prices in the US.")
			}
		});

	return {
		c() {
			create_component(tooltip.$$.fragment);
		},
		l(nodes) {
			claim_component(tooltip.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(tooltip, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const tooltip_changes = {};
			if (dirty[0] & /*name, solarStateRanks*/ 17) tooltip_changes.text = "" + (/*name*/ ctx[0] + " ranks #" + /*solarStateRanks*/ ctx[4].systemPriceRank + " for the top " + rankLimit + " cheapests system prices in the US.");
			tooltip.$set(tooltip_changes);
		},
		i(local) {
			if (current) return;
			transition_in(tooltip.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tooltip.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(tooltip, detaching);
		}
	};
}

// (227:12) {#if !selectedCounty && solarStateRanks}
function create_if_block_2(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_3, create_else_block_1];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if (/*solarStateRanks*/ ctx[4].paybackPeriodRank <= rankLimit) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_1(ctx, [-1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_1(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (233:14) {:else}
function create_else_block_1(ctx) {
	let tooltip;
	let current;

	tooltip = new Tooltip({
			props: {
				text: "" + (/*name*/ ctx[0] + " ranks #" + /*solarStateRanks*/ ctx[4].paybackPeriodRank + " for smallest payback periods in the US.")
			}
		});

	return {
		c() {
			create_component(tooltip.$$.fragment);
		},
		l(nodes) {
			claim_component(tooltip.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(tooltip, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const tooltip_changes = {};
			if (dirty[0] & /*name, solarStateRanks*/ 17) tooltip_changes.text = "" + (/*name*/ ctx[0] + " ranks #" + /*solarStateRanks*/ ctx[4].paybackPeriodRank + " for smallest payback periods in the US.");
			tooltip.$set(tooltip_changes);
		},
		i(local) {
			if (current) return;
			transition_in(tooltip.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tooltip.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(tooltip, detaching);
		}
	};
}

// (228:14) {#if solarStateRanks.paybackPeriodRank <= rankLimit}
function create_if_block_3(ctx) {
	let tooltip;
	let current;

	tooltip = new Tooltip({
			props: {
				icon: "green-star",
				text: "" + (/*name*/ ctx[0] + " ranks #" + /*solarStateRanks*/ ctx[4].paybackPeriodRank + " for the top " + rankLimit + " shortest payback periods in the US.")
			}
		});

	return {
		c() {
			create_component(tooltip.$$.fragment);
		},
		l(nodes) {
			claim_component(tooltip.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(tooltip, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const tooltip_changes = {};
			if (dirty[0] & /*name, solarStateRanks*/ 17) tooltip_changes.text = "" + (/*name*/ ctx[0] + " ranks #" + /*solarStateRanks*/ ctx[4].paybackPeriodRank + " for the top " + rankLimit + " shortest payback periods in the US.");
			tooltip.$set(tooltip_changes);
		},
		i(local) {
			if (current) return;
			transition_in(tooltip.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tooltip.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(tooltip, detaching);
		}
	};
}

// (259:12) {#if !selectedCounty && solarStateRanks}
function create_if_block(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_1, create_else_block];
	const if_blocks = [];

	function select_block_type_2(ctx, dirty) {
		if (/*solarStateRanks*/ ctx[4].yearsSavingsRank <= rankLimit) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_2(ctx, [-1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_2(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (265:14) {:else}
function create_else_block(ctx) {
	let tooltip;
	let current;

	tooltip = new Tooltip({
			props: {
				text: "" + (/*name*/ ctx[0] + " ranks #" + /*solarStateRanks*/ ctx[4].yearsSavingsRank + " for states with most savings in the US.")
			}
		});

	return {
		c() {
			create_component(tooltip.$$.fragment);
		},
		l(nodes) {
			claim_component(tooltip.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(tooltip, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const tooltip_changes = {};
			if (dirty[0] & /*name, solarStateRanks*/ 17) tooltip_changes.text = "" + (/*name*/ ctx[0] + " ranks #" + /*solarStateRanks*/ ctx[4].yearsSavingsRank + " for states with most savings in the US.");
			tooltip.$set(tooltip_changes);
		},
		i(local) {
			if (current) return;
			transition_in(tooltip.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tooltip.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(tooltip, detaching);
		}
	};
}

// (260:14) {#if solarStateRanks.yearsSavingsRank <= rankLimit}
function create_if_block_1(ctx) {
	let tooltip;
	let current;

	tooltip = new Tooltip({
			props: {
				icon: "green-star",
				text: "" + (/*name*/ ctx[0] + " ranks #" + /*solarStateRanks*/ ctx[4].yearsSavingsRank + " for the top " + rankLimit + " states with most savings in the US.")
			}
		});

	return {
		c() {
			create_component(tooltip.$$.fragment);
		},
		l(nodes) {
			claim_component(tooltip.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(tooltip, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const tooltip_changes = {};
			if (dirty[0] & /*name, solarStateRanks*/ 17) tooltip_changes.text = "" + (/*name*/ ctx[0] + " ranks #" + /*solarStateRanks*/ ctx[4].yearsSavingsRank + " for the top " + rankLimit + " states with most savings in the US.");
			tooltip.$set(tooltip_changes);
		},
		i(local) {
			if (current) return;
			transition_in(tooltip.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tooltip.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(tooltip, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div15;
	let section0;
	let statepath0;
	let t0;
	let section1;
	let div1;
	let h20;
	let t1;
	let t2;
	let t3;
	let t4_value = new Date().getFullYear() + "";
	let t4;
	let t5;
	let t6;
	let div0;
	let statepath1;
	let t7;
	let p0;
	let t8_value = /*data*/ ctx[3][`solar${capitalize(/*locationType*/ ctx[5])}HowMuchP1`].map(func).join(' ') + "";
	let t8;
	let t9;
	let p1;
	let t10_value = /*data*/ ctx[3][`solar${capitalize(/*locationType*/ ctx[5])}HowMuchP2`].map(func_1).join(' ') + "";
	let t10;
	let t11;
	let p2;
	let t12_value = /*data*/ ctx[3][`solarStateHowMuchP3`].map(func_2).join(' ') + "";
	let t12;
	let t13;
	let div8;
	let div3;
	let strong0;
	let t14;
	let t15;
	let t16;
	let t17;
	let span0;
	let t18;
	let t19;
	let div2;
	let span2;
	let span1;
	let t20_value = (/*selectedCounty*/ ctx[7] || /*name*/ ctx[0]) + "";
	let t20;
	let t21;
	let strong1;
	let t22;
	let t23;
	let t24;
	let span3;
	let t25;
	let strong2;
	let t26_value = /*getSystemPrice*/ ctx[16](defaultSize, true) + "";
	let t26;
	let t27;
	let div5;
	let strong3;
	let t28;
	let t29;
	let span4;
	let t30;
	let t31;
	let div4;
	let span6;
	let span5;
	let t32_value = (/*selectedCounty*/ ctx[7] || /*name*/ ctx[0]) + "";
	let t32;
	let t33;
	let strong4;
	let t34;
	let t35;
	let t36;
	let t37;
	let span7;
	let t38;
	let strong5;
	let t39_value = /*getPaybackPeriod*/ ctx[17](defaultSize, true) + "";
	let t39;
	let t40;
	let t41;
	let div7;
	let strong6;
	let t42;
	let t43;
	let span8;
	let t44;
	let t45;
	let div6;
	let span10;
	let span9;
	let t46_value = (/*selectedCounty*/ ctx[7] || /*name*/ ctx[0]) + "";
	let t46;
	let t47;
	let strong7;
	let t48;
	let t49;
	let t50;
	let span11;
	let t51;
	let strong8;
	let t52_value = /*get20YearSavings*/ ctx[18](defaultSize, true) + "";
	let t52;
	let t53;
	let section2;
	let div14;
	let img;
	let img_src_value;
	let t54;
	let div13;
	let h21;
	let t55;

	let t56_value = (/*selectedCounty*/ ctx[7]
	? /*selectedCounty*/ ctx[7]
	: /*name*/ ctx[0]) + "";

	let t56;
	let t57;
	let p3;
	let t58;
	let br;

	let t59_value = (/*selectedCounty*/ ctx[7]
	? /*selectedCounty*/ ctx[7]
	: /*name*/ ctx[0]) + "";

	let t59;
	let t60;
	let t61;
	let div12;
	let div9;
	let span12;
	let t62;
	let t63;
	let span13;
	let t64;
	let t65;
	let span14;
	let t66;
	let t67;
	let div10;
	let span15;
	let t68;
	let t69;
	let span16;
	let t70;
	let t71;
	let span17;
	let t72;
	let t73;
	let div11;
	let span18;
	let t74;
	let t75;
	let span19;
	let t76;
	let t77;
	let span20;
	let t78;
	let current;

	statepath0 = new StatePath({
			props: {
				state: /*state*/ ctx[15],
				counties: /*counties*/ ctx[1],
				preSelectedCounty: /*preSelectedCounty*/ ctx[14],
				standaloneState: true,
				style: "height: 25rem; fill: #566479;"
			}
		});

	statepath0.$on("clicked", /*countyClick*/ ctx[19]);
	let if_block0 = /*isCity*/ ctx[6] && create_if_block_6(ctx);

	statepath1 = new StatePath({
			props: {
				state: /*state*/ ctx[15],
				counties: /*counties*/ ctx[1],
				preSelectedCounty: /*preSelectedCounty*/ ctx[14],
				standaloneState: true,
				style: "max-height: 20rem;\n          fill: #566479;"
			}
		});

	let if_block1 = !/*selectedCounty*/ ctx[7] && /*solarStateRanks*/ ctx[4] && create_if_block_4(ctx);
	let if_block2 = !/*selectedCounty*/ ctx[7] && /*solarStateRanks*/ ctx[4] && create_if_block_2(ctx);
	let if_block3 = !/*selectedCounty*/ ctx[7] && /*solarStateRanks*/ ctx[4] && create_if_block(ctx);

	return {
		c() {
			div15 = element("div");
			section0 = element("section");
			create_component(statepath0.$$.fragment);
			t0 = space();
			section1 = element("section");
			div1 = element("div");
			h20 = element("h2");
			t1 = text("How much do solar panels cost in ");
			t2 = text(/*name*/ ctx[0]);
			if (if_block0) if_block0.c();
			t3 = text(" in ");
			t4 = text(t4_value);
			t5 = text("?");
			t6 = space();
			div0 = element("div");
			create_component(statepath1.$$.fragment);
			t7 = space();
			p0 = element("p");
			t8 = text(t8_value);
			t9 = space();
			p1 = element("p");
			t10 = text(t10_value);
			t11 = space();
			p2 = element("p");
			t12 = text(t12_value);
			t13 = space();
			div8 = element("div");
			div3 = element("div");
			strong0 = element("strong");
			t14 = text("Average out-of-pocket cost for a ");
			t15 = text(defaultSize);
			t16 = text(" kW system");
			t17 = space();
			span0 = element("span");
			t18 = text("The upfront amount spent to buy and install solar.");
			t19 = space();
			div2 = element("div");
			span2 = element("span");
			span1 = element("span");
			t20 = text(t20_value);
			t21 = text(": ");
			strong1 = element("strong");
			t22 = text(/*systemPriceCell*/ ctx[8]);
			t23 = space();
			if (if_block1) if_block1.c();
			t24 = space();
			span3 = element("span");
			t25 = text("US Average: ");
			strong2 = element("strong");
			t26 = text(t26_value);
			t27 = space();
			div5 = element("div");
			strong3 = element("strong");
			t28 = text("Average Payback Period");
			t29 = space();
			span4 = element("span");
			t30 = text("The number of years until you break even on the solar investment.");
			t31 = space();
			div4 = element("div");
			span6 = element("span");
			span5 = element("span");
			t32 = text(t32_value);
			t33 = text(": ");
			strong4 = element("strong");
			t34 = text(/*paybackPeriodCell*/ ctx[9]);
			t35 = text(" years");
			t36 = space();
			if (if_block2) if_block2.c();
			t37 = space();
			span7 = element("span");
			t38 = text("US Average: ");
			strong5 = element("strong");
			t39 = text(t39_value);
			t40 = text(" years");
			t41 = space();
			div7 = element("div");
			strong6 = element("strong");
			t42 = text("Average Net 20-year savings");
			t43 = space();
			span8 = element("span");
			t44 = text("The total amount of money saved over 20 years minus the out-of-pocket cost.");
			t45 = space();
			div6 = element("div");
			span10 = element("span");
			span9 = element("span");
			t46 = text(t46_value);
			t47 = text(": ");
			strong7 = element("strong");
			t48 = text(/*savingsCell*/ ctx[10]);
			t49 = space();
			if (if_block3) if_block3.c();
			t50 = space();
			span11 = element("span");
			t51 = text("US Average: ");
			strong8 = element("strong");
			t52 = text(t52_value);
			t53 = space();
			section2 = element("section");
			div14 = element("div");
			img = element("img");
			t54 = space();
			div13 = element("div");
			h21 = element("h2");
			t55 = text("Solar Potential in ");
			t56 = text(t56_value);
			t57 = space();
			p3 = element("p");
			t58 = text("Estimated system size and solar electricity production per median viable roof in");
			br = element("br");
			t59 = text(t59_value);
			t60 = text(".");
			t61 = space();
			div12 = element("div");
			div9 = element("div");
			span12 = element("span");
			t62 = text("Roof size");
			t63 = space();
			span13 = element("span");
			t64 = text(/*solarRoofSize*/ ctx[11]);
			t65 = space();
			span14 = element("span");
			t66 = text("sq. ft.");
			t67 = space();
			div10 = element("div");
			span15 = element("span");
			t68 = text("Capacity");
			t69 = space();
			span16 = element("span");
			t70 = text(/*solarCapacity*/ ctx[12]);
			t71 = space();
			span17 = element("span");
			t72 = text("kW DC");
			t73 = space();
			div11 = element("div");
			span18 = element("span");
			t74 = text("Electricity");
			t75 = space();
			span19 = element("span");
			t76 = text(/*solarElectricity*/ ctx[13]);
			t77 = space();
			span20 = element("span");
			t78 = text("kWh AC per yr.");
			this.h();
		},
		l(nodes) {
			div15 = claim_element(nodes, "DIV", { id: true, class: true });
			var div15_nodes = children(div15);
			section0 = claim_element(div15_nodes, "SECTION", { class: true });
			var section0_nodes = children(section0);
			claim_component(statepath0.$$.fragment, section0_nodes);
			section0_nodes.forEach(detach);
			t0 = claim_space(div15_nodes);
			section1 = claim_element(div15_nodes, "SECTION", { id: true, class: true });
			var section1_nodes = children(section1);
			div1 = claim_element(section1_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			h20 = claim_element(div1_nodes, "H2", { class: true });
			var h20_nodes = children(h20);
			t1 = claim_text(h20_nodes, "How much do solar panels cost in ");
			t2 = claim_text(h20_nodes, /*name*/ ctx[0]);
			if (if_block0) if_block0.l(h20_nodes);
			t3 = claim_text(h20_nodes, " in ");
			t4 = claim_text(h20_nodes, t4_value);
			t5 = claim_text(h20_nodes, "?");
			h20_nodes.forEach(detach);
			t6 = claim_space(div1_nodes);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			claim_component(statepath1.$$.fragment, div0_nodes);
			div0_nodes.forEach(detach);
			t7 = claim_space(div1_nodes);
			p0 = claim_element(div1_nodes, "P", {});
			var p0_nodes = children(p0);
			t8 = claim_text(p0_nodes, t8_value);
			p0_nodes.forEach(detach);
			t9 = claim_space(div1_nodes);
			p1 = claim_element(div1_nodes, "P", {});
			var p1_nodes = children(p1);
			t10 = claim_text(p1_nodes, t10_value);
			p1_nodes.forEach(detach);
			t11 = claim_space(div1_nodes);
			p2 = claim_element(div1_nodes, "P", {});
			var p2_nodes = children(p2);
			t12 = claim_text(p2_nodes, t12_value);
			p2_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			t13 = claim_space(section1_nodes);
			div8 = claim_element(section1_nodes, "DIV", { class: true });
			var div8_nodes = children(div8);
			div3 = claim_element(div8_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			strong0 = claim_element(div3_nodes, "STRONG", { class: true });
			var strong0_nodes = children(strong0);
			t14 = claim_text(strong0_nodes, "Average out-of-pocket cost for a ");
			t15 = claim_text(strong0_nodes, defaultSize);
			t16 = claim_text(strong0_nodes, " kW system");
			strong0_nodes.forEach(detach);
			t17 = claim_space(div3_nodes);
			span0 = claim_element(div3_nodes, "SPAN", { class: true });
			var span0_nodes = children(span0);
			t18 = claim_text(span0_nodes, "The upfront amount spent to buy and install solar.");
			span0_nodes.forEach(detach);
			t19 = claim_space(div3_nodes);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			span2 = claim_element(div2_nodes, "SPAN", { class: true });
			var span2_nodes = children(span2);
			span1 = claim_element(span2_nodes, "SPAN", {});
			var span1_nodes = children(span1);
			t20 = claim_text(span1_nodes, t20_value);
			t21 = claim_text(span1_nodes, ": ");
			strong1 = claim_element(span1_nodes, "STRONG", { class: true });
			var strong1_nodes = children(strong1);
			t22 = claim_text(strong1_nodes, /*systemPriceCell*/ ctx[8]);
			strong1_nodes.forEach(detach);
			span1_nodes.forEach(detach);
			t23 = claim_space(span2_nodes);
			if (if_block1) if_block1.l(span2_nodes);
			span2_nodes.forEach(detach);
			t24 = claim_space(div2_nodes);
			span3 = claim_element(div2_nodes, "SPAN", { class: true });
			var span3_nodes = children(span3);
			t25 = claim_text(span3_nodes, "US Average: ");
			strong2 = claim_element(span3_nodes, "STRONG", { class: true });
			var strong2_nodes = children(strong2);
			t26 = claim_text(strong2_nodes, t26_value);
			strong2_nodes.forEach(detach);
			span3_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			t27 = claim_space(div8_nodes);
			div5 = claim_element(div8_nodes, "DIV", { class: true });
			var div5_nodes = children(div5);
			strong3 = claim_element(div5_nodes, "STRONG", { class: true });
			var strong3_nodes = children(strong3);
			t28 = claim_text(strong3_nodes, "Average Payback Period");
			strong3_nodes.forEach(detach);
			t29 = claim_space(div5_nodes);
			span4 = claim_element(div5_nodes, "SPAN", { class: true });
			var span4_nodes = children(span4);
			t30 = claim_text(span4_nodes, "The number of years until you break even on the solar investment.");
			span4_nodes.forEach(detach);
			t31 = claim_space(div5_nodes);
			div4 = claim_element(div5_nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			span6 = claim_element(div4_nodes, "SPAN", { class: true });
			var span6_nodes = children(span6);
			span5 = claim_element(span6_nodes, "SPAN", {});
			var span5_nodes = children(span5);
			t32 = claim_text(span5_nodes, t32_value);
			t33 = claim_text(span5_nodes, ": ");
			strong4 = claim_element(span5_nodes, "STRONG", { class: true });
			var strong4_nodes = children(strong4);
			t34 = claim_text(strong4_nodes, /*paybackPeriodCell*/ ctx[9]);
			t35 = claim_text(strong4_nodes, " years");
			strong4_nodes.forEach(detach);
			span5_nodes.forEach(detach);
			t36 = claim_space(span6_nodes);
			if (if_block2) if_block2.l(span6_nodes);
			span6_nodes.forEach(detach);
			t37 = claim_space(div4_nodes);
			span7 = claim_element(div4_nodes, "SPAN", { class: true });
			var span7_nodes = children(span7);
			t38 = claim_text(span7_nodes, "US Average: ");
			strong5 = claim_element(span7_nodes, "STRONG", { class: true });
			var strong5_nodes = children(strong5);
			t39 = claim_text(strong5_nodes, t39_value);
			t40 = claim_text(strong5_nodes, " years");
			strong5_nodes.forEach(detach);
			span7_nodes.forEach(detach);
			div4_nodes.forEach(detach);
			div5_nodes.forEach(detach);
			t41 = claim_space(div8_nodes);
			div7 = claim_element(div8_nodes, "DIV", { class: true });
			var div7_nodes = children(div7);
			strong6 = claim_element(div7_nodes, "STRONG", { class: true });
			var strong6_nodes = children(strong6);
			t42 = claim_text(strong6_nodes, "Average Net 20-year savings");
			strong6_nodes.forEach(detach);
			t43 = claim_space(div7_nodes);
			span8 = claim_element(div7_nodes, "SPAN", { class: true });
			var span8_nodes = children(span8);
			t44 = claim_text(span8_nodes, "The total amount of money saved over 20 years minus the out-of-pocket cost.");
			span8_nodes.forEach(detach);
			t45 = claim_space(div7_nodes);
			div6 = claim_element(div7_nodes, "DIV", { class: true });
			var div6_nodes = children(div6);
			span10 = claim_element(div6_nodes, "SPAN", { class: true });
			var span10_nodes = children(span10);
			span9 = claim_element(span10_nodes, "SPAN", {});
			var span9_nodes = children(span9);
			t46 = claim_text(span9_nodes, t46_value);
			t47 = claim_text(span9_nodes, ": ");
			strong7 = claim_element(span9_nodes, "STRONG", { class: true });
			var strong7_nodes = children(strong7);
			t48 = claim_text(strong7_nodes, /*savingsCell*/ ctx[10]);
			strong7_nodes.forEach(detach);
			span9_nodes.forEach(detach);
			t49 = claim_space(span10_nodes);
			if (if_block3) if_block3.l(span10_nodes);
			span10_nodes.forEach(detach);
			t50 = claim_space(div6_nodes);
			span11 = claim_element(div6_nodes, "SPAN", { class: true });
			var span11_nodes = children(span11);
			t51 = claim_text(span11_nodes, "US Average: ");
			strong8 = claim_element(span11_nodes, "STRONG", { class: true });
			var strong8_nodes = children(strong8);
			t52 = claim_text(strong8_nodes, t52_value);
			strong8_nodes.forEach(detach);
			span11_nodes.forEach(detach);
			div6_nodes.forEach(detach);
			div7_nodes.forEach(detach);
			div8_nodes.forEach(detach);
			section1_nodes.forEach(detach);
			t53 = claim_space(div15_nodes);
			section2 = claim_element(div15_nodes, "SECTION", { class: true });
			var section2_nodes = children(section2);
			div14 = claim_element(section2_nodes, "DIV", { class: true });
			var div14_nodes = children(div14);
			img = claim_element(div14_nodes, "IMG", { src: true, alt: true, class: true });
			t54 = claim_space(div14_nodes);
			div13 = claim_element(div14_nodes, "DIV", { class: true });
			var div13_nodes = children(div13);
			h21 = claim_element(div13_nodes, "H2", { class: true });
			var h21_nodes = children(h21);
			t55 = claim_text(h21_nodes, "Solar Potential in ");
			t56 = claim_text(h21_nodes, t56_value);
			h21_nodes.forEach(detach);
			t57 = claim_space(div13_nodes);
			p3 = claim_element(div13_nodes, "P", { class: true });
			var p3_nodes = children(p3);
			t58 = claim_text(p3_nodes, "Estimated system size and solar electricity production per median viable roof in");
			br = claim_element(p3_nodes, "BR", {});
			t59 = claim_text(p3_nodes, t59_value);
			t60 = claim_text(p3_nodes, ".");
			p3_nodes.forEach(detach);
			t61 = claim_space(div13_nodes);
			div12 = claim_element(div13_nodes, "DIV", { class: true });
			var div12_nodes = children(div12);
			div9 = claim_element(div12_nodes, "DIV", { class: true });
			var div9_nodes = children(div9);
			span12 = claim_element(div9_nodes, "SPAN", { class: true });
			var span12_nodes = children(span12);
			t62 = claim_text(span12_nodes, "Roof size");
			span12_nodes.forEach(detach);
			t63 = claim_space(div9_nodes);
			span13 = claim_element(div9_nodes, "SPAN", { class: true });
			var span13_nodes = children(span13);
			t64 = claim_text(span13_nodes, /*solarRoofSize*/ ctx[11]);
			span13_nodes.forEach(detach);
			t65 = claim_space(div9_nodes);
			span14 = claim_element(div9_nodes, "SPAN", { class: true });
			var span14_nodes = children(span14);
			t66 = claim_text(span14_nodes, "sq. ft.");
			span14_nodes.forEach(detach);
			div9_nodes.forEach(detach);
			t67 = claim_space(div12_nodes);
			div10 = claim_element(div12_nodes, "DIV", { class: true });
			var div10_nodes = children(div10);
			span15 = claim_element(div10_nodes, "SPAN", { class: true });
			var span15_nodes = children(span15);
			t68 = claim_text(span15_nodes, "Capacity");
			span15_nodes.forEach(detach);
			t69 = claim_space(div10_nodes);
			span16 = claim_element(div10_nodes, "SPAN", { class: true });
			var span16_nodes = children(span16);
			t70 = claim_text(span16_nodes, /*solarCapacity*/ ctx[12]);
			span16_nodes.forEach(detach);
			t71 = claim_space(div10_nodes);
			span17 = claim_element(div10_nodes, "SPAN", { class: true });
			var span17_nodes = children(span17);
			t72 = claim_text(span17_nodes, "kW DC");
			span17_nodes.forEach(detach);
			div10_nodes.forEach(detach);
			t73 = claim_space(div12_nodes);
			div11 = claim_element(div12_nodes, "DIV", { class: true });
			var div11_nodes = children(div11);
			span18 = claim_element(div11_nodes, "SPAN", { class: true });
			var span18_nodes = children(span18);
			t74 = claim_text(span18_nodes, "Electricity");
			span18_nodes.forEach(detach);
			t75 = claim_space(div11_nodes);
			span19 = claim_element(div11_nodes, "SPAN", { class: true });
			var span19_nodes = children(span19);
			t76 = claim_text(span19_nodes, /*solarElectricity*/ ctx[13]);
			span19_nodes.forEach(detach);
			t77 = claim_space(div11_nodes);
			span20 = claim_element(div11_nodes, "SPAN", { class: true });
			var span20_nodes = children(span20);
			t78 = claim_text(span20_nodes, "kWh AC per yr.");
			span20_nodes.forEach(detach);
			div11_nodes.forEach(detach);
			div12_nodes.forEach(detach);
			div13_nodes.forEach(detach);
			div14_nodes.forEach(detach);
			section2_nodes.forEach(detach);
			div15_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(section0, "class", "state-map state-map--desktop svelte-pw6h00");
			toggle_class(section0, "state-map--disabled", /*isCity*/ ctx[6]);
			attr(h20, "class", "overview__title overview__border");
			attr(div0, "class", "state-map state-map--mobile svelte-pw6h00");
			attr(div1, "class", "row");
			attr(strong0, "class", "d-block compare-table__row-title svelte-pw6h00");
			attr(span0, "class", "d-block compare-table__row-description svelte-pw6h00");
			attr(strong1, "class", "svelte-pw6h00");
			attr(span2, "class", "compare-table__left-val svelte-pw6h00");
			toggle_class(span2, "compare-table__left-val--gray", /*solarStateRanks*/ ctx[4] && /*solarStateRanks*/ ctx[4].systemPriceRank > rankLimit && !/*selectedCounty*/ ctx[7]);
			toggle_class(span2, "compare-table__left-val--blue", /*selectedCounty*/ ctx[7] || !/*solarStateRanks*/ ctx[4]);
			attr(strong2, "class", "svelte-pw6h00");
			attr(span3, "class", "compare-table__right-val svelte-pw6h00");
			attr(div2, "class", "compare-table__cells svelte-pw6h00");
			attr(div3, "class", "compare-table__row svelte-pw6h00");
			attr(strong3, "class", "d-block compare-table__row-title svelte-pw6h00");
			attr(span4, "class", "d-block compare-table__row-description svelte-pw6h00");
			attr(strong4, "class", "svelte-pw6h00");
			attr(span6, "class", "compare-table__left-val svelte-pw6h00");
			toggle_class(span6, "compare-table__left-val--gray", /*solarStateRanks*/ ctx[4] && /*solarStateRanks*/ ctx[4].paybackPeriodRank > rankLimit && !/*selectedCounty*/ ctx[7]);
			toggle_class(span6, "compare-table__left-val--blue", /*selectedCounty*/ ctx[7] || !/*solarStateRanks*/ ctx[4]);
			attr(strong5, "class", "svelte-pw6h00");
			attr(span7, "class", "compare-table__right-val svelte-pw6h00");
			attr(div4, "class", "compare-table__cells svelte-pw6h00");
			attr(div5, "class", "compare-table__row svelte-pw6h00");
			attr(strong6, "class", "d-block compare-table__row-title svelte-pw6h00");
			attr(span8, "class", "d-block compare-table__row-description svelte-pw6h00");
			attr(strong7, "class", "svelte-pw6h00");
			attr(span10, "class", "compare-table__left-val svelte-pw6h00");
			toggle_class(span10, "compare-table__left-val--gray", /*solarStateRanks*/ ctx[4] && /*solarStateRanks*/ ctx[4].yearsSavingsRank > rankLimit && !/*selectedCounty*/ ctx[7]);
			toggle_class(span10, "compare-table__left-val--blue", /*selectedCounty*/ ctx[7] || !/*solarStateRanks*/ ctx[4]);
			attr(strong8, "class", "svelte-pw6h00");
			attr(span11, "class", "compare-table__right-val svelte-pw6h00");
			attr(div6, "class", "compare-table__cells svelte-pw6h00");
			attr(div7, "class", "compare-table__row svelte-pw6h00");
			attr(div8, "class", "overview__compare-table compare-table row svelte-pw6h00");
			attr(section1, "id", "solar-panels-costs");
			attr(section1, "class", "container text-content svelte-pw6h00");
			if (!src_url_equal(img.src, img_src_value = "/site-images/sun.svg")) attr(img, "src", img_src_value);
			attr(img, "alt", "");
			attr(img, "class", "svelte-pw6h00");
			attr(h21, "class", "solar-potential__title svelte-pw6h00");
			attr(p3, "class", "solar-potential__paragraph svelte-pw6h00");
			attr(span12, "class", "solar-potential__stat-name svelte-pw6h00");
			attr(span13, "class", "solar-potential__stat-val svelte-pw6h00");
			attr(span14, "class", "solar-potential__stat-suffix svelte-pw6h00");
			attr(div9, "class", "solar-potential__stat svelte-pw6h00");
			attr(span15, "class", "solar-potential__stat-name svelte-pw6h00");
			attr(span16, "class", "solar-potential__stat-val svelte-pw6h00");
			attr(span17, "class", "solar-potential__stat-suffix svelte-pw6h00");
			attr(div10, "class", "solar-potential__stat svelte-pw6h00");
			attr(span18, "class", "solar-potential__stat-name svelte-pw6h00");
			attr(span19, "class", "solar-potential__stat-val svelte-pw6h00");
			attr(span20, "class", "solar-potential__stat-suffix svelte-pw6h00");
			attr(div11, "class", "solar-potential__stat svelte-pw6h00");
			attr(div12, "class", "solar-potential__stats svelte-pw6h00");
			attr(div13, "class", "solar-potential__content");
			attr(div14, "class", "solar-potential__wrapper svelte-pw6h00");
			attr(section2, "class", "solar-potential container svelte-pw6h00");
			attr(div15, "id", "overview-hero");
			attr(div15, "class", "overview svelte-pw6h00");
		},
		m(target, anchor) {
			insert_hydration(target, div15, anchor);
			append_hydration(div15, section0);
			mount_component(statepath0, section0, null);
			append_hydration(div15, t0);
			append_hydration(div15, section1);
			append_hydration(section1, div1);
			append_hydration(div1, h20);
			append_hydration(h20, t1);
			append_hydration(h20, t2);
			if (if_block0) if_block0.m(h20, null);
			append_hydration(h20, t3);
			append_hydration(h20, t4);
			append_hydration(h20, t5);
			append_hydration(div1, t6);
			append_hydration(div1, div0);
			mount_component(statepath1, div0, null);
			append_hydration(div1, t7);
			append_hydration(div1, p0);
			append_hydration(p0, t8);
			append_hydration(div1, t9);
			append_hydration(div1, p1);
			append_hydration(p1, t10);
			append_hydration(div1, t11);
			append_hydration(div1, p2);
			append_hydration(p2, t12);
			append_hydration(section1, t13);
			append_hydration(section1, div8);
			append_hydration(div8, div3);
			append_hydration(div3, strong0);
			append_hydration(strong0, t14);
			append_hydration(strong0, t15);
			append_hydration(strong0, t16);
			append_hydration(div3, t17);
			append_hydration(div3, span0);
			append_hydration(span0, t18);
			append_hydration(div3, t19);
			append_hydration(div3, div2);
			append_hydration(div2, span2);
			append_hydration(span2, span1);
			append_hydration(span1, t20);
			append_hydration(span1, t21);
			append_hydration(span1, strong1);
			append_hydration(strong1, t22);
			append_hydration(span2, t23);
			if (if_block1) if_block1.m(span2, null);
			append_hydration(div2, t24);
			append_hydration(div2, span3);
			append_hydration(span3, t25);
			append_hydration(span3, strong2);
			append_hydration(strong2, t26);
			append_hydration(div8, t27);
			append_hydration(div8, div5);
			append_hydration(div5, strong3);
			append_hydration(strong3, t28);
			append_hydration(div5, t29);
			append_hydration(div5, span4);
			append_hydration(span4, t30);
			append_hydration(div5, t31);
			append_hydration(div5, div4);
			append_hydration(div4, span6);
			append_hydration(span6, span5);
			append_hydration(span5, t32);
			append_hydration(span5, t33);
			append_hydration(span5, strong4);
			append_hydration(strong4, t34);
			append_hydration(strong4, t35);
			append_hydration(span6, t36);
			if (if_block2) if_block2.m(span6, null);
			append_hydration(div4, t37);
			append_hydration(div4, span7);
			append_hydration(span7, t38);
			append_hydration(span7, strong5);
			append_hydration(strong5, t39);
			append_hydration(strong5, t40);
			append_hydration(div8, t41);
			append_hydration(div8, div7);
			append_hydration(div7, strong6);
			append_hydration(strong6, t42);
			append_hydration(div7, t43);
			append_hydration(div7, span8);
			append_hydration(span8, t44);
			append_hydration(div7, t45);
			append_hydration(div7, div6);
			append_hydration(div6, span10);
			append_hydration(span10, span9);
			append_hydration(span9, t46);
			append_hydration(span9, t47);
			append_hydration(span9, strong7);
			append_hydration(strong7, t48);
			append_hydration(span10, t49);
			if (if_block3) if_block3.m(span10, null);
			append_hydration(div6, t50);
			append_hydration(div6, span11);
			append_hydration(span11, t51);
			append_hydration(span11, strong8);
			append_hydration(strong8, t52);
			append_hydration(div15, t53);
			append_hydration(div15, section2);
			append_hydration(section2, div14);
			append_hydration(div14, img);
			append_hydration(div14, t54);
			append_hydration(div14, div13);
			append_hydration(div13, h21);
			append_hydration(h21, t55);
			append_hydration(h21, t56);
			append_hydration(div13, t57);
			append_hydration(div13, p3);
			append_hydration(p3, t58);
			append_hydration(p3, br);
			append_hydration(p3, t59);
			append_hydration(p3, t60);
			append_hydration(div13, t61);
			append_hydration(div13, div12);
			append_hydration(div12, div9);
			append_hydration(div9, span12);
			append_hydration(span12, t62);
			append_hydration(div9, t63);
			append_hydration(div9, span13);
			append_hydration(span13, t64);
			append_hydration(div9, t65);
			append_hydration(div9, span14);
			append_hydration(span14, t66);
			append_hydration(div12, t67);
			append_hydration(div12, div10);
			append_hydration(div10, span15);
			append_hydration(span15, t68);
			append_hydration(div10, t69);
			append_hydration(div10, span16);
			append_hydration(span16, t70);
			append_hydration(div10, t71);
			append_hydration(div10, span17);
			append_hydration(span17, t72);
			append_hydration(div12, t73);
			append_hydration(div12, div11);
			append_hydration(div11, span18);
			append_hydration(span18, t74);
			append_hydration(div11, t75);
			append_hydration(div11, span19);
			append_hydration(span19, t76);
			append_hydration(div11, t77);
			append_hydration(div11, span20);
			append_hydration(span20, t78);
			current = true;
		},
		p(ctx, dirty) {
			const statepath0_changes = {};
			if (dirty[0] & /*counties*/ 2) statepath0_changes.counties = /*counties*/ ctx[1];
			statepath0.$set(statepath0_changes);

			if (dirty[0] & /*isCity*/ 64) {
				toggle_class(section0, "state-map--disabled", /*isCity*/ ctx[6]);
			}

			if (!current || dirty[0] & /*name*/ 1) set_data(t2, /*name*/ ctx[0]);

			if (/*isCity*/ ctx[6]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_6(ctx);
					if_block0.c();
					if_block0.m(h20, t3);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			const statepath1_changes = {};
			if (dirty[0] & /*counties*/ 2) statepath1_changes.counties = /*counties*/ ctx[1];
			statepath1.$set(statepath1_changes);
			if ((!current || dirty[0] & /*data, locationType*/ 40) && t8_value !== (t8_value = /*data*/ ctx[3][`solar${capitalize(/*locationType*/ ctx[5])}HowMuchP1`].map(func).join(' ') + "")) set_data(t8, t8_value);
			if ((!current || dirty[0] & /*data, locationType*/ 40) && t10_value !== (t10_value = /*data*/ ctx[3][`solar${capitalize(/*locationType*/ ctx[5])}HowMuchP2`].map(func_1).join(' ') + "")) set_data(t10, t10_value);
			if ((!current || dirty[0] & /*data*/ 8) && t12_value !== (t12_value = /*data*/ ctx[3][`solarStateHowMuchP3`].map(func_2).join(' ') + "")) set_data(t12, t12_value);
			if ((!current || dirty[0] & /*selectedCounty, name*/ 129) && t20_value !== (t20_value = (/*selectedCounty*/ ctx[7] || /*name*/ ctx[0]) + "")) set_data(t20, t20_value);
			if (!current || dirty[0] & /*systemPriceCell*/ 256) set_data(t22, /*systemPriceCell*/ ctx[8]);

			if (!/*selectedCounty*/ ctx[7] && /*solarStateRanks*/ ctx[4]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*selectedCounty, solarStateRanks*/ 144) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_4(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(span2, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (dirty[0] & /*solarStateRanks, selectedCounty*/ 144) {
				toggle_class(span2, "compare-table__left-val--gray", /*solarStateRanks*/ ctx[4] && /*solarStateRanks*/ ctx[4].systemPriceRank > rankLimit && !/*selectedCounty*/ ctx[7]);
			}

			if (dirty[0] & /*selectedCounty, solarStateRanks*/ 144) {
				toggle_class(span2, "compare-table__left-val--blue", /*selectedCounty*/ ctx[7] || !/*solarStateRanks*/ ctx[4]);
			}

			if ((!current || dirty[0] & /*selectedCounty, name*/ 129) && t32_value !== (t32_value = (/*selectedCounty*/ ctx[7] || /*name*/ ctx[0]) + "")) set_data(t32, t32_value);
			if (!current || dirty[0] & /*paybackPeriodCell*/ 512) set_data(t34, /*paybackPeriodCell*/ ctx[9]);

			if (!/*selectedCounty*/ ctx[7] && /*solarStateRanks*/ ctx[4]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[0] & /*selectedCounty, solarStateRanks*/ 144) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_2(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(span6, null);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if (dirty[0] & /*solarStateRanks, selectedCounty*/ 144) {
				toggle_class(span6, "compare-table__left-val--gray", /*solarStateRanks*/ ctx[4] && /*solarStateRanks*/ ctx[4].paybackPeriodRank > rankLimit && !/*selectedCounty*/ ctx[7]);
			}

			if (dirty[0] & /*selectedCounty, solarStateRanks*/ 144) {
				toggle_class(span6, "compare-table__left-val--blue", /*selectedCounty*/ ctx[7] || !/*solarStateRanks*/ ctx[4]);
			}

			if ((!current || dirty[0] & /*selectedCounty, name*/ 129) && t46_value !== (t46_value = (/*selectedCounty*/ ctx[7] || /*name*/ ctx[0]) + "")) set_data(t46, t46_value);
			if (!current || dirty[0] & /*savingsCell*/ 1024) set_data(t48, /*savingsCell*/ ctx[10]);

			if (!/*selectedCounty*/ ctx[7] && /*solarStateRanks*/ ctx[4]) {
				if (if_block3) {
					if_block3.p(ctx, dirty);

					if (dirty[0] & /*selectedCounty, solarStateRanks*/ 144) {
						transition_in(if_block3, 1);
					}
				} else {
					if_block3 = create_if_block(ctx);
					if_block3.c();
					transition_in(if_block3, 1);
					if_block3.m(span10, null);
				}
			} else if (if_block3) {
				group_outros();

				transition_out(if_block3, 1, 1, () => {
					if_block3 = null;
				});

				check_outros();
			}

			if (dirty[0] & /*solarStateRanks, selectedCounty*/ 144) {
				toggle_class(span10, "compare-table__left-val--gray", /*solarStateRanks*/ ctx[4] && /*solarStateRanks*/ ctx[4].yearsSavingsRank > rankLimit && !/*selectedCounty*/ ctx[7]);
			}

			if (dirty[0] & /*selectedCounty, solarStateRanks*/ 144) {
				toggle_class(span10, "compare-table__left-val--blue", /*selectedCounty*/ ctx[7] || !/*solarStateRanks*/ ctx[4]);
			}

			if ((!current || dirty[0] & /*selectedCounty, name*/ 129) && t56_value !== (t56_value = (/*selectedCounty*/ ctx[7]
			? /*selectedCounty*/ ctx[7]
			: /*name*/ ctx[0]) + "")) set_data(t56, t56_value);

			if ((!current || dirty[0] & /*selectedCounty, name*/ 129) && t59_value !== (t59_value = (/*selectedCounty*/ ctx[7]
			? /*selectedCounty*/ ctx[7]
			: /*name*/ ctx[0]) + "")) set_data(t59, t59_value);

			if (!current || dirty[0] & /*solarRoofSize*/ 2048) set_data(t64, /*solarRoofSize*/ ctx[11]);
			if (!current || dirty[0] & /*solarCapacity*/ 4096) set_data(t70, /*solarCapacity*/ ctx[12]);
			if (!current || dirty[0] & /*solarElectricity*/ 8192) set_data(t76, /*solarElectricity*/ ctx[13]);
		},
		i(local) {
			if (current) return;
			transition_in(statepath0.$$.fragment, local);
			transition_in(statepath1.$$.fragment, local);
			transition_in(if_block1);
			transition_in(if_block2);
			transition_in(if_block3);
			current = true;
		},
		o(local) {
			transition_out(statepath0.$$.fragment, local);
			transition_out(statepath1.$$.fragment, local);
			transition_out(if_block1);
			transition_out(if_block2);
			transition_out(if_block3);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div15);
			destroy_component(statepath0);
			if (if_block0) if_block0.d();
			destroy_component(statepath1);
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
		}
	};
}

const rankLimit = 10;
const defaultSize = 5;

function capitalize(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

const func = v => v.value;
const func_1 = v => v.value;
const func_2 = v => v.value;

function instance($$self, $$props, $$invalidate) {
	let { name, counties, locationInfo, data } = $$props;
	let { solarStateRanks = null } = $$props;
	let { locationType } = $$props;
	let { isCity = false } = $$props;
	let { nationalPricePerWatt = 3.82 } = $$props;
	const maxSize = locationInfo.systemSizes[locationInfo.systemSizes.length - 1];
	let selectedCounty;
	let preSelectedCounty = isCity ? locationInfo.cityCountySlug : null;
	let countyPricePerWatt;
	let egKey = '';
	const stateSlug = locationInfo.state_slug.toLowerCase();

	const state = {
		name: name.replace(/ /g, '-').toLowerCase(),
		slug: stateSlug
	};

	const stateUtilityBill = locationInfo.electricity_bill_12_month * 12;
	const nationalUtilityBill = locationInfo.national_electricity_bill_12_month * 12;

	const getSystemPrice = (systemSize, usAverage = false) => {
		const cpw = usAverage
		? nationalPricePerWatt
		: countyPricePerWatt
			? countyPricePerWatt
			: locationInfo.avgPricePerWatt;

		const price = roundFormat(cpw * systemSize * 1000 * 0.7);
		return '$' + price;
	};

	const getPaybackPeriod = (systemSize, usAverage = false) => {
		const cpw = usAverage
		? nationalPricePerWatt
		: countyPricePerWatt
			? countyPricePerWatt
			: locationInfo.avgPricePerWatt;

		const price = cpw * systemSize * 1000 * 0.7;
		return Math.round(price / (usAverage ? nationalUtilityBill : stateUtilityBill));
	};

	const get20YearSavings = (systemSize, usAverage = false) => {
		const cpw = usAverage
		? nationalPricePerWatt
		: countyPricePerWatt
			? countyPricePerWatt
			: locationInfo.avgPricePerWatt;

		const price = cpw * systemSize * 1000;

		const bills = usAverage
		? nationalUtilityBill * 20
		: stateUtilityBill * 20;

		return '$' + roundFormat(bills - price);
	};

	const getSolarRoofSize = solarData => {
		if (solarData) {
			return roundFormat(solarData.numberOfPanelsMedian * 3.25 * 5.5);
		}

		return roundFormat(locationInfo.solarPotential.roof);
	};

	const getSolarCapacity = solarData => {
		if (solarData) {
			return roundToMax2Decimals(solarData.kwMedian);
		}

		return roundToMax2Decimals(locationInfo.solarPotential.system);
	};

	const getSolarElectricity = solarData => {
		if (solarData) {
			return formatBigNumber(solarData.yearlySunlightKwhMedian);
		}

		return formatBigNumber(locationInfo.solarPotential.energy);
	};

	let systemPriceCell = getSystemPrice(defaultSize);
	let paybackPeriodCell = getPaybackPeriod(defaultSize);
	let savingsCell = get20YearSavings(defaultSize);
	let solarRoofSize = getSolarRoofSize();
	let solarCapacity = getSolarCapacity();
	let solarElectricity = getSolarElectricity();

	const countyClick = async event => {
		if (isCity) return;
		$$invalidate(7, selectedCounty = event.detail.county.name);
		countyPricePerWatt = event.detail.county.price_per_watt;
		$$invalidate(8, systemPriceCell = getSystemPrice(defaultSize));
		$$invalidate(9, paybackPeriodCell = getPaybackPeriod(defaultSize));
		$$invalidate(10, savingsCell = get20YearSavings(defaultSize));
		let solarData = null;

		if (event.detail.county.name) {
			const response = await graphql(getCountyData({ id: event.detail.county.id }), { 'eg-key': egKey });
			solarData = response.data.result.nodes[0];
		}

		$$invalidate(11, solarRoofSize = getSolarRoofSize(solarData));
		$$invalidate(12, solarCapacity = getSolarCapacity(solarData));
		$$invalidate(13, solarElectricity = getSolarElectricity(solarData));
	};

	const graphql = getGraphqlClient();

	const getCountyData = gql`
    query countyData($id: Int!) {
      __typename
      result: allSunRoofDataForCounties(condition: { countyId: $id }) {
        nodes {
          yearlySunlightKwhMedian
          kwMedian
          numberOfPanelsMedian
        }
      }
    }
  `;

	onMount(() => {
		const egKeyDiv = document.getElementById('eg-key');
		egKey = egKeyDiv ? egKeyDiv.dataset.egKey : '';
	});

	$$self.$$set = $$props => {
		if ('name' in $$props) $$invalidate(0, name = $$props.name);
		if ('counties' in $$props) $$invalidate(1, counties = $$props.counties);
		if ('locationInfo' in $$props) $$invalidate(2, locationInfo = $$props.locationInfo);
		if ('data' in $$props) $$invalidate(3, data = $$props.data);
		if ('solarStateRanks' in $$props) $$invalidate(4, solarStateRanks = $$props.solarStateRanks);
		if ('locationType' in $$props) $$invalidate(5, locationType = $$props.locationType);
		if ('isCity' in $$props) $$invalidate(6, isCity = $$props.isCity);
		if ('nationalPricePerWatt' in $$props) $$invalidate(20, nationalPricePerWatt = $$props.nationalPricePerWatt);
	};

	return [
		name,
		counties,
		locationInfo,
		data,
		solarStateRanks,
		locationType,
		isCity,
		selectedCounty,
		systemPriceCell,
		paybackPeriodCell,
		savingsCell,
		solarRoofSize,
		solarCapacity,
		solarElectricity,
		preSelectedCounty,
		state,
		getSystemPrice,
		getPaybackPeriod,
		get20YearSavings,
		countyClick,
		nationalPricePerWatt
	];
}

class Hero extends SvelteComponent {
	constructor(options) {
		super();

		init(
			this,
			options,
			instance,
			create_fragment,
			safe_not_equal,
			{
				name: 0,
				counties: 1,
				locationInfo: 2,
				data: 3,
				solarStateRanks: 4,
				locationType: 5,
				isCity: 6,
				nationalPricePerWatt: 20
			},
			null,
			[-1, -1]
		);
	}
}

export default Hero;